/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetRowsGeoParams,
  HTTPValidationError,
  RowGeoBulkUpdate,
  RowGeoResponse,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getRowsGeoResponse200 = {
  data: RowGeoResponse[];
  status: 200;
};

export type getRowsGeoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getRowsGeoResponseSuccess = getRowsGeoResponse200 & {
  headers: Headers;
};
export type getRowsGeoResponseError = getRowsGeoResponse422 & {
  headers: Headers;
};

export type getRowsGeoResponse =
  getRowsGeoResponseSuccess | getRowsGeoResponseError;

export const getGetRowsGeoUrl = (params?: GetRowsGeoParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/rows-geo/?${stringifiedParams}`
    : `/api/rows-geo/`;
};

/**
 * @summary List rows; plot_id, trial_id, or location_uuid is required
 */
export const getRowsGeo = async (
  params?: GetRowsGeoParams,
  options?: RequestInit,
): Promise<getRowsGeoResponse> => {
  const res = await fetch(getGetRowsGeoUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRowsGeoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getRowsGeoResponse;
};

export const getGetRowsGeoQueryKey = (params?: GetRowsGeoParams) => {
  return [`/api/rows-geo/`, ...(params ? [params] : [])] as const;
};

export const getGetRowsGeoQueryOptions = <
  TData = Awaited<ReturnType<typeof getRowsGeo>>,
  TError = HTTPValidationError,
>(
  params?: GetRowsGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowsGeo>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRowsGeoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRowsGeo>>> = ({
    signal,
  }) => getRowsGeo(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRowsGeo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRowsGeoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRowsGeo>>
>;
export type GetRowsGeoQueryError = HTTPValidationError;

export function useGetRowsGeo<
  TData = Awaited<ReturnType<typeof getRowsGeo>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetRowsGeoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowsGeo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRowsGeo>>,
          TError,
          Awaited<ReturnType<typeof getRowsGeo>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRowsGeo<
  TData = Awaited<ReturnType<typeof getRowsGeo>>,
  TError = HTTPValidationError,
>(
  params?: GetRowsGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowsGeo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRowsGeo>>,
          TError,
          Awaited<ReturnType<typeof getRowsGeo>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRowsGeo<
  TData = Awaited<ReturnType<typeof getRowsGeo>>,
  TError = HTTPValidationError,
>(
  params?: GetRowsGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowsGeo>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List rows; plot_id, trial_id, or location_uuid is required
 */

export function useGetRowsGeo<
  TData = Awaited<ReturnType<typeof getRowsGeo>>,
  TError = HTTPValidationError,
>(
  params?: GetRowsGeoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRowsGeo>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRowsGeoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateRowsGeoBulkResponse200 = {
  data: RowGeoResponse[];
  status: 200;
};

export type updateRowsGeoBulkResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateRowsGeoBulkResponseSuccess = updateRowsGeoBulkResponse200 & {
  headers: Headers;
};
export type updateRowsGeoBulkResponseError = updateRowsGeoBulkResponse422 & {
  headers: Headers;
};

export type updateRowsGeoBulkResponse =
  updateRowsGeoBulkResponseSuccess | updateRowsGeoBulkResponseError;

export const getUpdateRowsGeoBulkUrl = () => {
  return `/api/rows-geo/bulk`;
};

/**
 * Update many row boundaries in one request.
 *
 * New polygons must not overlap. Together with the other rows of each
 * parent plot, they must exactly split that plot: inside it, and covering it.
 * @summary Update Rows Geo Bulk Route
 */
export const updateRowsGeoBulk = async (
  rowGeoBulkUpdate: RowGeoBulkUpdate,
  options?: RequestInit,
): Promise<updateRowsGeoBulkResponse> => {
  const res = await fetch(getUpdateRowsGeoBulkUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rowGeoBulkUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateRowsGeoBulkResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateRowsGeoBulkResponse;
};

export const getUpdateRowsGeoBulkMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRowsGeoBulk>>,
    TError,
    { data: RowGeoBulkUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRowsGeoBulk>>,
  TError,
  { data: RowGeoBulkUpdate },
  TContext
> => {
  const mutationKey = ["updateRowsGeoBulk"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRowsGeoBulk>>,
    { data: RowGeoBulkUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateRowsGeoBulk(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRowsGeoBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRowsGeoBulk>>
>;
export type UpdateRowsGeoBulkMutationBody = RowGeoBulkUpdate;
export type UpdateRowsGeoBulkMutationError = HTTPValidationError;

/**
 * @summary Update Rows Geo Bulk Route
 */
export const useUpdateRowsGeoBulk = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRowsGeoBulk>>,
      TError,
      { data: RowGeoBulkUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateRowsGeoBulk>>,
  TError,
  { data: RowGeoBulkUpdate },
  TContext
> => {
  return useMutation(getUpdateRowsGeoBulkMutationOptions(options), queryClient);
};
